@import "src/style/lib";

.news-wrapper {
  width: 90%;
  margin: 2em auto;

  @include media-breakpoint-between("sm", "lg") {
    width: 80%;
  }
  @include media-breakpoint-up("lg") {
    width: 66.7%;
  }

  .news-meta {
    text-transform: uppercase;
    font-size: 0.8em;
    color: $bjelin-grey;
    margin-bottom: 1em;
  }

  .news-link {
    margin: 2.8em 0;
  }

  .contacts {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0;
    margin-left: 0;
    margin-bottom: 2rem;
    justify-content: flex-start;
    @include make-row(0);

    .contact-person {
      @include make-col-ready;

      @include media-breakpoint-up("md") {
        @include make-col(6);
      }

      background: $bjelin-smoke;
      padding: 2em;
      text-align: center;

      .contact-image {
        display: block;
        width: 8em;
        height: 8em;
        margin: 0 auto 1em;
        object-fit: cover;
        border-radius: 50%;
      }

      .contact-name {
        margin-bottom: 0.4em;
      }

      .contact-title {
        text-transform: uppercase;
        font-size: 0.8em;
        color: $bjelin-grey;
        margin-bottom: 1em;
      }
    }
  }

  .news-media {
    ul {
      display: block;
      margin-top: 1rem;

      li {
        display: block;
      }
    }
  }
}
